"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _animejs = _interopRequireDefault(require("animejs")),
    _classnames = _interopRequireDefault(require("classnames")),
    _DragHandler = _interopRequireDefault(require("../../DragHandler"));

require("../styles/_seek-bar.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var SKIP_AMOUNT = 1,
    KEY_CODES = {
  left: 37,
  right: 39
},
    SEEK_BAR_CLASS = "seek-bar",
    SEEK_BAR_FILL_CLASS = "seek-bar__fill",
    SEEK_BAR_HANDLE_CLASS = "seek-bar__handle";

function hasSeekTimeChanged(a, b, c) {
  return a ? Math.abs(b - c) >= SKIP_AMOUNT : b !== c;
}

function attemptToUpdateSeekBarWidth(a, b, c) {
  if (b.current && c.current) {
    var d = b.current.style;
    d.width = "".concat(a, "%");
    var e = c.current.style;
    e.left = "calc(".concat(a, "% - 5px)");
  }
}

function calculateLeftSeconds(a) {
  var b = a.totalDuration,
      c = a.currentTime;
  return b - c;
}

var SeekBar = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.handleSeekChange = function (a) {
      var b = a.x,
          c = d.props,
          e = c.totalDuration,
          f = c.onSetManualTime;

      if (d._barRef) {
        var g = d._barRef.current;

        if (g) {
          var h = g.offsetWidth,
              i = g.getBoundingClientRect(),
              j = i.left,
              k = b - j,
              l = k > h ? h : k;
          if (0 >= l) return void f(0);
          var m = l / h,
              n = e * m;
          attemptToUpdateSeekBarWidth(100 * m, d._fillRef, d._handleRef), d.setAnimation(n), f(n);
        }
      }
    }, d.setFocus = function () {
      document.addEventListener("keydown", d.handleManualSeekMove);
    }, d.setBlur = function () {
      document.removeEventListener("keydown", d.handleManualSeekMove);
    }, d.handleManualSeekMove = function (a) {
      var b = a.keyCode,
          c = d.props,
          e = c.totalDuration,
          f = c.onSetManualTime,
          g = c.currentTime;

      if (b === KEY_CODES.left || b === KEY_CODES.right) {
        var h = b === KEY_CODES.left ? g - 5 : g + 5,
            i = 0 > h ? 0 : h,
            j = i > e ? e : i;
        attemptToUpdateSeekBarWidth(100 * (j / e), d._fillRef, d._handleRef), d.setAnimation(j), f(j);
      }
    }, d._barRef = _react["default"].createRef(), d._fillRef = _react["default"].createRef(), d._handleRef = _react["default"].createRef(), d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(a) {
      var b = this.props,
          c = b.currentTime,
          d = b.isPlaying,
          e = b.totalDuration,
          f = b.commentModalId;
      return d !== a.isPlaying || hasSeekTimeChanged(d, c, a.currentTime) || e !== a.totalDuration || !a.currentTime && c || !!(a.commentModalId && a.commentModalId !== f);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(a) {
      var b = a.currentTime,
          c = this.props,
          d = c.currentTime,
          e = c.totalDuration,
          f = c.isPlaying;

      if (!d && b && attemptToUpdateSeekBarWidth(0, this._fillRef, this._handleRef), hasSeekTimeChanged(f, b, d)) {
        attemptToUpdateSeekBarWidth(100 * (d / e), this._fillRef, this._handleRef);
      }

      this.setAnimation();
    }
  }, {
    key: "setAnimation",
    value: function setAnimation(a) {
      var b = this.props,
          c = b.isPlaying,
          d = b.isBuffering;
      if (!c || d) return void this.pauseAnimation();
      var e = this.props,
          f = e.currentTime,
          g = e.totalDuration,
          h = calculateLeftSeconds({
        currentTime: a || f,
        totalDuration: g
      });
      this._animation && this.pauseAnimation();
      var i = {
        duration: 1e3 * h,
        easing: "linear",
        autoplay: !0,
        loop: !1
      };
      this._animation = (0, _animejs["default"])(_objectSpread({
        targets: this._fillRef.current,
        width: "100%"
      }, i)), this._markerAnimation = (0, _animejs["default"])(_objectSpread({
        targets: this._handleRef.current,
        left: "calc(100% - 5px)"
      }, i));
    }
  }, {
    key: "pauseAnimation",
    value: function pauseAnimation() {
      this._animation && this._markerAnimation && (this._animation.pause(), this._markerAnimation.pause());
    }
  }, {
    key: "render",
    value: function render() {
      var a = this,
          b = this.props.loading;
      return _react["default"].createElement(_DragHandler["default"], {
        onDrag: this.handleSeekChange,
        cursor: "grab"
      }, function (c) {
        var d = c.onMouseDown,
            e = c.isDragging;
        return _react["default"].createElement("div", {
          className: (0, _classnames["default"])(SEEK_BAR_CLASS, (0, _defineProperty2["default"])({}, "".concat(SEEK_BAR_CLASS, "--dragging"), e), (0, _defineProperty2["default"])({}, "".concat(SEEK_BAR_CLASS, "--loading"), b)),
          onMouseDown: d,
          role: "button",
          tabIndex: 0,
          onFocus: a.setFocus,
          onBlur: a.setBlur,
          ref: a._barRef
        }, _react["default"].createElement("div", {
          className: SEEK_BAR_HANDLE_CLASS,
          ref: a._handleRef
        }), _react["default"].createElement("div", {
          className: (0, _classnames["default"])(SEEK_BAR_FILL_CLASS, (0, _defineProperty2["default"])({}, "".concat(SEEK_BAR_FILL_CLASS, "--dragging"), e)),
          ref: a._fillRef
        }));
      });
    }
  }]), b;
}(_react.Component);

exports["default"] = SeekBar;